import React from "react";
import {
  SelectDropdown,
  type OptionItem,
} from "@/components/formfields/SelectDropdown";
import { Loader2 } from "lucide-react";

export interface TemplateSelectorProps {
  value: string;
  onChange: (value: string) => void;
  options: OptionItem[];
  isLoading?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  className?: string;
}

export function TemplateSelector({
  value,
  onChange,
  options,
  isLoading = false,
  disabled = false,
  label = "Template Selection",
  placeholder = "Select export template...",
  className = "",
}: TemplateSelectorProps) {
  return (
    <div className={className}>
      {label && (
        <label className="text-sm font-semibold mb-2 block text-slate-900 dark:text-slate-100">
          {label}
        </label>
      )}
      {isLoading ? (
        <div className="flex items-center gap-2 h-10 px-3 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-400 text-sm">
          <Loader2 className="w-4 h-4 animate-spin text-purple-600" />
          Loading templates...
        </div>
      ) : (
        <SelectDropdown
          options={options}
          value={value}
          onChange={(val) => onChange(String(val))}
          placeholder={placeholder}
          clearable={false}
          disabled={disabled}
        />
      )}
    </div>
  );
}

export default TemplateSelector;
